import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../orderSettingActions';
import {
  setDeliveryAddressesFormIsVisible,
  setGuestDeliveryAddressFormInitialValues,
} from '../../DeliveryAddresses/deliveryAddressesActions';
import {
  setDropOffLocationFormIsVisible,
  getFirstDropOffSelection,
  getSingleHotelTable,
  setIsEditDropOffLocation,
  deleteDropOffLocation,
  restoreSelectedLocation,
} from '../../DropOff/dropOffLocationActions';
import { resetGuestSession } from '../../Auth/authActions';
import {
  validateGlobalCart,
  updateCartWithUnavailbleProducts,
  emptyCart,
  validateCartForLocation,
  clearErrorMessage,
} from '../../Cart/cartActions';
import { PICKUP, DELIVERY, DROPOFF } from '../orderSettingTypes';
import Dialog from '../../../components/Dialog/Dialog';
import { withStyles } from '@material-ui/core/styles';
//import {DialogContent, Box} from '@material-ui/core';
import OrderSettingModal from './OrderSettingModal';
import OrderingClosedContainer from '../OrderingClosed/OrderingClosedContainer';
import appConfigFile from '../../../../app-config';
import { connectSearchBox } from 'react-instantsearch-dom';
import { navigate } from 'gatsby';
import { getMenu } from '../../OnAppLoad/Menu/menuActions';
import { isInteger } from 'lodash';
import _ from 'lodash';
const styles = () => ({
  scrollPaper: {},
  paper: {
    margin: 0,
    maxHeight: '90%',
    overflowY: 'visible',
    width: appConfigFile.isParentChildClient ? '1000px' : '380px',
    maxWidth: appConfigFile.isParentChildClient ? '1000px' : '450px',
    minWidth: '350px',
  },
});

const OrderSettingModalContainer = ({
  classes,
  orderSettingReducer,
  updateInterOrderType,
  locations,
  updateInterPickUpDetails,
  deliveryAddressesList,
  updateInterDeliveryDetails,
  updateInterSelectedDateTime,
  getTimeIntervalsDate,
  updateOrderSettingModalIsVisible,
  confirmPickUpDetails,
  resetInterSelectedDateTime,
  resetDateTimes,
  requestingGetLocations,
  confirmDeliveryDetails,
  setDeliveryAddressesFormIsVisible,
  validateGlobalCart, //GLOBAL CART
  resetIsTimeNoLongerValid,
  currentLocation,
  isAuthenticated,
  isGuestSession,
  hideToolTip,
  nearestLocation,
  orderHistory,
  cartReducer,
  updateCartWithUnavailbleProducts,
  emptyCart,
  orderingClosedInAllLocations,
  getBusinessSpecialHours,
  getChildLocations,
  setChildLocation,
  setDropOffLocationFormIsVisible,
  updateInterDropOffDetails,
  confirmDropOffDetails,
  getFirstDropOffSelection,
  getSingleHotelTable,
  dropOffLocationReducer,
  setIsEditDropOffLocation,
  deleteDropOffLocation,
  restoreSelectedLocation,
  refine,
  updateSelectedLocation,
  deliveryToAddress,
  deepLinkParameters,
  checkUnavailableProductForPickUp,
  guestDeliveryFormInitialAddress,
  setGuestDeliveryAddressFormInitialValues,
  appConfig,
  validateCartForLocation,
  resetGuestSession,
  getMenu,
  clearErrorMessage,
  updateOrderType,
}) => {
  const [showConfirmButton, setShowConfirmButton] = useState(true);
  const cartItems = {
    products: cartReducer.products,
    combos: cartReducer.combos,
  };
  const {
    orderType,
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    availableTimes,
    interSelectedDateTime,
    orderSettingModalIsVisible,
    isRequesting,
    toolTipIsHidden,
    selectedDateTime,
    isTimeNoLongerValid,
    specialHours,
    childLocations,
    orderPacingData,
    selectedLocation,
    cartErrorMessage,
  } = orderSettingReducer;
  const { unavailableProducts, isStoreOffline } = cartReducer;
  const currentPath = window.location.href;
  const {
    pickedDropOffLocation,
    dropOffLocations,
    selectedDropOffLocation,
    getDropOffLocationsIsRequesting,
  } = dropOffLocationReducer;

  const handleConfirmPickupButton = (location) => {
    if (!isAuthenticated && !isGuestSession) {
      emptyCart();
    } else {
      if (unavailableProducts && unavailableProducts.length) {
        const unavailableProductsModified = unavailableProducts.map(
          (product) => product.product_id
        );
        updateCartWithUnavailbleProducts(unavailableProducts);
        updateCartWithUnavailbleProducts(unavailableProductsModified);
        clearErrorMessage();
      }
    }

    updateSelectedLocation(location);
    updateInterPickUpDetails(location, new Date().toString());
    confirmPickUpDetails(true);
    validateGlobalCart(false, isStoreOffline, location.id, false);
    if (currentPath.includes('storeId')) {
      navigate('/');
    }
    if (
      appConfigFile.isGlobalSearchEnabled &&
      (!selectedLocation.accepting_orders || !selectedLocation.open) &&
      !selectedLocation.is_future_order_enabled &&
      !selectedLocation.is_order_ahead_enabled
    ) {
      refine('');
    }
  };

  const handleConfirmDeliveryButton = (location) => {
    if (!isAuthenticated && !isGuestSession) {
      emptyCart();
    } else {
      if (unavailableProducts && unavailableProducts.length > 0) {
        const unavailableProductsModified = unavailableProducts.map(
          (product) => product.product_id
        );
        updateCartWithUnavailbleProducts(unavailableProducts);
        updateCartWithUnavailbleProducts(unavailableProductsModified);
        clearErrorMessage();
      }
    }
    validateGlobalCart(
      false,
      isStoreOffline,
      location.deliveryBusiness.id,
      false,
      location.id
    );
    updateSelectedLocation(location);
    updateInterDeliveryDetails(location);
    confirmDeliveryDetails(true);
    if (currentPath.includes('storeId')) {
      navigate('/');
    }
  };

  const handleConfirmDropOffButton = () => {
    if (!isAuthenticated && !isGuestSession) {
      emptyCart();
    } else {
      if (unavailableProducts && unavailableProducts.length) {
        const unavailableProductsModified = unavailableProducts.map(
          (product) => product.product_id
        );
        updateCartWithUnavailbleProducts(unavailableProductsModified);
        clearErrorMessage();
      }
    }
    confirmDropOffDetails(true);
  };

  const getBusinessInfo = useCallback(() => {
    if (selectedLocation) {
      const id =
        interOrderType === DELIVERY
          ? selectedLocation?.deliveryBusiness?.id
          : selectedLocation?.id;

      getBusinessSpecialHours(selectedLocation, interOrderType);
      getTimeIntervalsDate(id, new Date().toString());
      if (
        !selectedDateTime?.dateTime?.date?.name &&
        !selectedDateTime?.dateTime?.time?.name
      ) {
        updateInterSelectedDateTime({
          radioValue: {
            name: 'As soon as possible',
            value: 'asap',
          },
          dateTime: {
            date: {
              name: moment().format('ddd MMM DD'),
              value: moment().toString(),
            },
            time: {
              name: '',
              value: '',
            },
          },
        });
      }
    }
  }, [selectedLocation]);

  useEffect(() => {
    getBusinessInfo();
  }, [getBusinessInfo]);

  useEffect(() => {
    let id = null;
    let type = null;
    if (interOrderType === PICKUP && selectedLocation) {
      type = 'pickup';
      id = selectedLocation.id;
    } else if (
      interOrderType === DELIVERY &&
      selectedLocation &&
      selectedLocation.deliveryBusiness
    ) {
      type = 'delivery';
      id = selectedLocation.deliveryBusiness.id;
    } else if (interOrderType === DROPOFF && interDropOffDetails) {
      type = 'drop_off';
      id = interDropOffDetails.id;
    }
    if (id && type) {
      localStorage.setItem('business_id', id);
      localStorage.setItem('order_type', type);
    }
  }, [selectedLocation, interDropOffDetails, interOrderType]);

  useEffect(() => {
    if (cartReducer.errors) clearErrorMessage();
  }, [interOrderType]);
  const query = new URLSearchParams(window.location.search);
  const deeplinkStoreId = query.get('storeId');
  const deeplinktype = query.get('type');
  // const updateDeeplinkLocation = useCallback(() => {
  //   if (locations.length > 0 && appConfig) {
  //     const acceptedOrderTypes = Object.keys(appConfig.accepted_order_types);
  //     if (deeplinkStoreId) {
  //       const deepLinkLocation = locations?.find(
  //         (location) => location.id === parseInt(deeplinkStoreId)
  //       );
  //       if (deeplinktype && acceptedOrderTypes.includes(deeplinktype)) {
  //         if (acceptedOrderTypes.length === 1) {
  //           updateInterOrderType(acceptedOrderTypes[0]);
  //           updateOrderType(acceptedOrderTypes[0]);

  //           if (acceptedOrderTypes[0] === PICKUP) {
  //             updateSelectedLocation(deepLinkLocation);
  //           }
  //         } else {
  //           if (deeplinktype === PICKUP) {
  //             updateInterOrderType(deeplinktype);
  //             updateOrderType(deeplinktype);
  //             updateSelectedLocation(deepLinkLocation);
  //           } else if (deeplinktype === DELIVERY) {
  //             updateInterOrderType(deeplinktype);
  //             updateOrderType(deeplinktype);
  //           }
  //         }
  //       } else {
  //         if (interOrderType === 'pickup') {
  //           updateSelectedLocation(deepLinkLocation);
  //           updateOrderType('pickup');
  //         } else {
  //           updateOrderType('delivery');
  //         }
  //       }
  //     } else {
  //       if (interOrderType === 'pickup') {
  //         updateOrderType('pickup');
  //       } else {
  //         updateOrderType('delivery');
  //       }
  //     }
  //   }
  // }, [deeplinkStoreId, deeplinktype, locations, appConfig]);
  // useEffect(() => {
  //   updateDeeplinkLocation();
  // }, [updateDeeplinkLocation]);
  return (
    <>
      <Dialog
        open={orderSettingModalIsVisible}
        onClose={() => {
          updateOrderSettingModalIsVisible(false);
          if (orderType === DROPOFF) {
            restoreSelectedLocation();
          }
        }}
        classes={{ scrollPaper: classes.scrollPaper }}
        PaperProps={{ classes: { root: classes.paper } }}
        aria-labelledby='order-method'
        scroll='body'
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <OrderSettingModal
          cartItems={cartItems}
          interOrderType={interOrderType}
          updateInterOrderType={updateInterOrderType}
          locations={locations}
          currentLocation={currentLocation}
          updateInterPickUpDetails={updateInterPickUpDetails}
          interPickUpDetails={interPickUpDetails}
          deliveryAddressesList={deliveryAddressesList}
          updateInterDeliveryDetails={updateInterDeliveryDetails}
          interDeliveryDetails={interDeliveryDetails}
          availableTimes={availableTimes}
          interSelectedDateTime={interSelectedDateTime}
          updateInterSelectedDateTime={updateInterSelectedDateTime}
          getTimeIntervalsDate={getTimeIntervalsDate}
          updateOrderSettingModalIsVisible={updateOrderSettingModalIsVisible}
          confirmPickUpDetails={confirmPickUpDetails}
          unavailableProducts={unavailableProducts}
          resetInterSelectedDateTime={resetInterSelectedDateTime}
          deliveryBusiness={
            interDeliveryDetails && interDeliveryDetails.deliveryBusiness
          }
          resetDateTimes={resetDateTimes}
          isRequesting={isRequesting}
          requestingGetLocations={requestingGetLocations}
          isTimeNoLongerValid={isTimeNoLongerValid}
          resetIsTimeNoLongerValid={resetIsTimeNoLongerValid}
          confirmDeliveryDetails={confirmDeliveryDetails}
          handleConfirmPickupButton={handleConfirmPickupButton}
          handleConfirmDeliveryButton={handleConfirmDeliveryButton}
          setDeliveryAddressesFormIsVisible={setDeliveryAddressesFormIsVisible}
          isAuthenticated={isAuthenticated}
          hideToolTip={hideToolTip}
          selectedDateTime={selectedDateTime}
          toolTipIsHidden={toolTipIsHidden}
          orderHistory={orderHistory}
          nearestLocation={nearestLocation}
          specialHours={specialHours}
          orderPacingData={orderPacingData}
          setDropOffLocationFormIsVisible={setDropOffLocationFormIsVisible}
          interDropOffDetails={interDropOffDetails}
          updateInterDropOffDetails={updateInterDropOffDetails}
          confirmDropOffDetails={confirmDropOffDetails}
          getFirstDropOffSelection={getFirstDropOffSelection}
          getSingleHotelTable={getSingleHotelTable}
          pickedDropOffLocation={pickedDropOffLocation}
          setIsEditDropOffLocation={setIsEditDropOffLocation}
          deleteDropOffLocation={deleteDropOffLocation}
          handleConfirmDropOffButton={handleConfirmDropOffButton}
          dropOffLocations={dropOffLocations}
          selectedDropOffLocation={selectedDropOffLocation}
          getDropOffLocationsIsRequesting={getDropOffLocationsIsRequesting}
          refine={refine}
          selectedLocation={selectedLocation}
          orderSettingModalIsVisible={orderSettingModalIsVisible}
          updateSelectedLocation={updateSelectedLocation}
          cartErrorMessage={cartErrorMessage}
          deliveryToAddress={deliveryToAddress}
          deepLinkParameters={deepLinkParameters}
          validateGlobalCart={validateGlobalCart}
          checkUnavailableProductForPickUp={checkUnavailableProductForPickUp}
          guestDeliveryFormInitialAddress={guestDeliveryFormInitialAddress}
          setGuestDeliveryAddressFormInitialValues={
            setGuestDeliveryAddressFormInitialValues
          }
          appConfig={appConfig}
          cartReducer={cartReducer}
          validateCartForLocation={validateCartForLocation}
          getMenu={getMenu}
          emptyCart={emptyCart}
          updateCartWithUnavailbleProducts={updateCartWithUnavailbleProducts}
          showConfirmButton={showConfirmButton}
          setShowConfirmButton={setShowConfirmButton}
        />
      </Dialog>

      <OrderingClosedContainer />
    </>
  );
};

const mapStateToProps = (state) => ({
  orderSettingReducer: state.orderSettingReducer,
  locations: state.locationsReducer.locations,
  deliveryAddressesList: state.deliveryAddressesReducer.deliveryAddressesList,
  dropOffLocationReducer: state.dropOffLocationReducer,
  requestingGetLocations: state.locationsReducer.requestingGetLocations,
  isAuthenticated: state.authReducer.isAuthenticated,
  isGuestSession: state.authReducer.isGuestSession,
  currentLocation: state.locationsReducer.currentLocation,
  orderHistory: state.myTransactionsReducer.myTransactions,
  cartReducer: state.cartReducer,
  orderingClosedInAllLocations:
    state.locationsReducer.orderingClosedInAllLocations,
  deliveryToAddress: state.deliveryAddressesReducer.deliveryToAddress,
  deepLinkParameters: state.deepLinkReducer.parameters,
  guestDeliveryFormInitialAddress:
    state.deliveryAddressesReducer.guestDeliveryFormInitialAddress,
  appConfig: state.authReducer.appConfig,
});

export default withStyles(styles)(
  connect(mapStateToProps, {
    ...actions,
    setDeliveryAddressesFormIsVisible,
    validateGlobalCart,
    updateCartWithUnavailbleProducts,
    emptyCart,
    setIsEditDropOffLocation,
    deleteDropOffLocation,
    setDropOffLocationFormIsVisible,
    getFirstDropOffSelection,
    getSingleHotelTable,
    restoreSelectedLocation,
    setGuestDeliveryAddressFormInitialValues,
    validateCartForLocation,
    resetGuestSession,
    getMenu,
    clearErrorMessage,
  })(
    appConfigFile.isGlobalSearchEnabled
      ? connectSearchBox(OrderSettingModalContainer)
      : OrderSettingModalContainer
  )
);
